import { updateInitialConfig, updateModifiedConfig } from "../checksumStore";

export const updateScreenChecksum = (screenData, screenName, isInit = false) => {
  let storeConfig = {};

  if (screenName === "header") {
    storeConfig = {
      header_config: screenData.header_config || {},
      z_admin_config: screenData.z_admin_config || {},
      module_header_config: screenData.module_header_config || []
    };
  } else {
    // config = screenData?.config || {};
    const { description, config, folder_info_tag, info_tag, position_screen_config, is_positioned_screen } = screenData;
    storeConfig = {
      description,
      config,
      folder_info_tag,
      info_tag,
      position_screen_config: position_screen_config || [],
      is_positioned_screen: is_positioned_screen || false
    };
  }
  if (isInit) {
    updateInitialConfig(storeConfig);
  } else {
    updateModifiedConfig(storeConfig);
  }
  return storeConfig;
};
